export default class NodeType {
  constructor(data = {}) {
    Object.keys(data).forEach(key => {
      if (key === 'extensionTypeCountMap') {
        this.dropExtensionTypeMap = new Map(data[key])
      }
      this[key] = data[key]
    })
  }
}
